import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { Fade, FadeOut, FadeComplete } from '../../state/engine.actions';
import { takeUntil } from 'rxjs/operators';
import { trigger, transition, sequence, style, animate, state, keyframes, AnimationReferenceMetadata, animation, useAnimation } from '@angular/animations';

const easing = 'ease-out';

const fadeIn: AnimationReferenceMetadata = animation([
  style({ opacity: '0', backgroundColor: '*' }),
  sequence([
    animate('{{ duration }}ms {{ easing }}', style({ opacity: 1, backgroundColor: '{{ backgroundColor }}'})),
    animate('250ms 500ms ease-in', style({ opacity: 0 }))
  ])
], { params: { duration: 2000, backgroundColor: '#ffffff', easing: easing}});

@Component({
  selector: 'app-engine-fade',
  templateUrl: './engine-fade.component.html',
  styleUrls: ['./engine-fade.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fade', [
      transition('* => true', useAnimation(fadeIn))
    ])
  ]
})
export class EngineFadeComponent implements OnInit, OnDestroy {
  color = '#FFFFFF';
  duration = 2000;
  isVisible = false;
  ngUnsubscribe = new Subject();

  constructor(
    private actions: Actions,
    private changeDetectorRef: ChangeDetectorRef,
    private store: Store
  ) { }

  ngOnInit() {
    this.initFadeListener();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  initFadeListener() {
    this.actions.pipe(
      ofActionDispatched(Fade),
      takeUntil(this.ngUnsubscribe)
    ).subscribe((action: Fade) => {
      this.fadeIn(action.color, action.duration);
    });
  }

  handleFadeComplete() {
    this.store.dispatch(new FadeComplete());
    this.isVisible = false;
    this.changeDetectorRef.markForCheck();
  }

  fadeIn(color: string, duration: number) {
    this.isVisible = true;
    this.color = color;
    this.duration = duration * 1000;
    
    this.changeDetectorRef.markForCheck();
  }
}
